<template>
  <!-- wrapper(s) -->
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header ref="header" class="header" data-title="렌탈" type="join"></Header>
    <div class="container">
      <!-- content(s) -->
      <div v-if="!userInfo" id="content">
        <section class="new_h">
          <div class="resultMsg hko onlyMsg">
            <p class="copy">주문이 완료 되었습니다.</p>

            <ul v-if="coupon" class="couponList mt20">
              <li>
                <a class="block bgColor0">
                  <div class="inner">
                    <strong class="copy medium">{{ coupon.title }}</strong>
                    <span class="desc">렌탈전용 웰몰쿠폰</span>
                  </div>
                </a>
              </li>
            </ul>

            <p v-if="coupon" class="desc">최대 할인 혜택이 적용 되었어요.</p>
          </div>
        </section>

        <section>
          <div class="banner slide" id="slide1">
            <ul class="slideList">
              <li v-for="(value, key) in bannerList" :key="key">
                <a @click="$router.push(value.bannerUrl)">
                  <img :src="value.imgURL" :alt="value.bannerName" />
                </a>
              </li>
            </ul>
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="$router.push('/')">확인</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
      <!-- content(s) -->
      <div v-else id="content">
        <section class="new_h">
          <div class="resultMsg hko onlyMsg">
            <p class="copy">주문이 완료 되었습니다.</p>

            <ul v-if="coupon" class="couponList mt20">
              <li>
                <a class="block bgColor0">
                  <div class="inner">
                    <strong class="copy medium">{{ coupon.title }}</strong>
                    <span class="desc">렌탈전용 웰몰쿠폰</span>
                  </div>
                </a>
              </li>
            </ul>

            <p v-if="coupon" class="desc">최대 할인 혜택이 적용 되었어요.</p>
          </div>
        </section>

        <section>
          <!-- <div class="banner">
            <ul class="slideList">
              <li>
                <a href="#link"><img src="https://www.welrixrental.co.kr/img_1/welmall_comm_img/1598485812217_temp_banner_ev01.png" alt="" /></a>
              </li>
            </ul>
          </div> -->
          <div class="banner slide" id="slide1">
            <ul class="slideList">
              <li v-for="(value, key) in bannerList" :key="key">
                <a @click="$router.push(value.bannerUrl)">
                  <img :src="value.imgURL" :alt="value.bannerName" />
                </a>
              </li>
            </ul>
          </div>
        </section>

        <section v-if="userInfo">
          <div class="btnArea">
            <button @click="$router.push('/myPage')" type="button" class="btn_p">마이페이지 가기</button>
          </div>
        </section>
        <QuickMenu></QuickMenu>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import * as customjs from '@/../static/js/m.front.js';
import QuickMenu from '@/views/app/comm/QuickMenu';
import $ from 'jquery';

export default {
  name: 'guestRentalEnd',
  components: { QuickMenu },
  data: function() {
    return {
      bannerList: [],
      agreeAppPush: this.$route.params.agreeAppPush,
      userInfo: false,
      coupon: this.$route.params.coupon,
    };
  },
  mounted() {
    if (JwtService.getToken()) {
      this.userInfo = true;
    } else {
      this.$refs.header.pushUpdate(this.agreeAppPush, null);
    }

    ApiService.service('GET', 'resource/banner/27')
      .then(({ data }) => {
        console.log(data);
        this.bannerList = data.result[0].bannerDtos;
        setTimeout(function() {
          customjs.slideInit('#slide1', 0, false, 500, false, 'auto', 10);
        }, 100);
      })
      .catch(({ response }) => {
        console.log(response);
      });
  },
  updated() {
    $('.goTop').remove();
  },
};
</script>
